let supported = true

try {
  'a'.localeCompare('b', 'i')
} catch (e) {
  if (e.name !== 'RangeError') {
    supported = false
  }
}

let compareFunction: (a: string, b: string) => number

if (supported) {
  compareFunction = function(a: string, b: string) {
    return a.localeCompare(b, undefined, { sensitivity: 'base', numeric: true })
  }
} else {
  compareFunction = function(a: string, b: string) {
    return a.toLowerCase().localeCompare(b.toLowerCase())
  }
}

export default compareFunction

// export default function(a: string, b: string) {
//   if (supported) {
//     return a.localeCompare(b, undefined, { sensitivity: 'base', numeric: true })
//   } else {
//     return a.toLowerCase().localeCompare(b.toLowerCase())
//   }
// }
